import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import {Provider} from "react-redux";
import store from "./features/store";
import reportWebVitals from "./reportWebVitals";
import {theme} from "./style/base/MuiTheme";
import {ThemeProvider} from "@mui/material/styles";
import {SnackbarProvider, closeSnackbar} from "notistack";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{horizontal: "right", vertical: "bottom"}}
        action={(snackbarId) => (
          <span
            className="dismiss-btn"
            onClick={() => closeSnackbar(snackbarId)}
          >
            Dismiss{" "}
          </span>
        )}
      >
        <App />
      </SnackbarProvider>{" "}
    </ThemeProvider>{" "}
  </Provider>
);

reportWebVitals();
